import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Rating} from "@mantine/core";
import {InputHelp} from "./InputHelp";

const normalizeRating = (value) => {
    const rating = Number(value);
    return Number.isInteger(rating * 2) && rating >= 1 && rating <= 5 ? rating : 0;
};

export const EditableRating = ({finishCallback, value: initialValue, patchField, disabled, style}) => {
    const [value, setValue] = useState(normalizeRating(initialValue));
    const [error, setError] = useState(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setValue(normalizeRating(initialValue));
    }, [initialValue]);

    function selectRating(rating) {
        if (disabled || loading || rating < 1 || rating > 5) {
            return;
        }

        setValue(rating);
        setError(undefined);
        setLoading(true);

        finishCallback({[patchField]: rating})
            .catch((saveError) => {
                setValue(normalizeRating(initialValue));
                setError(saveError.message);
            })
            .then(() => setLoading(false));
    }

    return (
        <div style={{marginBottom: 9, ...style}}>
            <Rating
                count={5}
                fractions={2}
                value={value}
                onChange={selectRating}
                readOnly={disabled || loading}
                size="md"
                getSymbolLabel={(rating) => `${rating} / 5`}
                name={patchField}
            />
            {error ? <InputHelp errorDescription={error}/> : null}
        </div>
    );
};

EditableRating.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    finishCallback: PropTypes.func.isRequired,
    patchField: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    style: PropTypes.object,
};
